(($, Drupal) => {
  const initTextboxCollapse = (el) => {
    const $this = $(el);
    const collapseTextBtn = $this.find('.btn[data-action="collapse-text"]');
    const expandTextBtn = $this.find('.btn[data-action="expand-text"]');

    if (expandTextBtn.length === 0) {
      return;
    }

    const maxHeight = 360;

    const fullText = $this.find('.text-box__col');

    let fullTextScrollHeight = $(fullText).height();

    if (fullTextScrollHeight > maxHeight) {
      expandTextBtn.show();

      fullText.css({ height: `${maxHeight}px`, overflow: 'hidden' });

      fullText.show();
    }

    const scrollToTopTextBox = (element) => {
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $this.offset().top - 100,
        },
        10,
      );

      element.off('transitionrun', null, scrollToTopTextBox);
    };

    const onExpandTextEnd = () => {
      fullText.css('overflow', 'visible');

      fullText.off('transitionend', null, onExpandTextEnd);
    };

    const onCollapseText = () => {
      scrollToTopTextBox($this);

      fullText.off('transitionrun', null, onCollapseText);
    };

    expandTextBtn.on('click', () => {
      fullText.css({
        height: fullTextScrollHeight,
        transition: 'height 0.3s ease-in-out',
      });
      collapseTextBtn.show();
      expandTextBtn.hide();

      fullText.on('transitionend', onExpandTextEnd);
    });

    collapseTextBtn.on('click', () => {
      fullText.css({
        height: maxHeight,
        transition: 'height 0.3s ease-in-out',
        overflow: 'hidden',
      });
      collapseTextBtn.hide();
      expandTextBtn.show();

      fullText.on('transitionrun', onCollapseText);
    });

    const resetHeights = () => {
      fullText.css({ height: 'initial' });
      fullTextScrollHeight = $(fullText).height();

      expandTextBtn.hide();

      if (fullTextScrollHeight > maxHeight) {
        fullText.css({
          height: maxHeight,
          transition: 'height 0.3s ease-in-out',
          overflow: 'hidden',
        });
        collapseTextBtn.hide();
        expandTextBtn.show();

        fullText.on('transitionrun', onCollapseText);
      }
    };

    $(window).on('resize', () => {
      resetHeights();
    });
  };

  Drupal.behaviors.mstTextboxCollapse = {
    attach: (context) => {
      $('.text-box--collapse-text', context).each((index, element) => initTextboxCollapse(element));
    },
  };
})(jQuery, Drupal);
